export interface Work {
  id: string;
  title: string;
  korean: string;
  genre: string;
  tags: string[];
  status: string;
  rating: string;
  chapters: string;
  update: string;
  desc: string;
  image: string;
  hot?: boolean;
  new?: boolean;
  color: string;
}

export const works: Work[] = [
  {
    id: 'w1',
    title: '成为暴君的贴身医女',
    korean: '폭군의 곁에서',
    genre: '宫廷 · 逆袭',
    tags: ['言情', '复仇', '女主成长'],
    status: '连载中',
    rating: '9.6',
    chapters: '全 128 话',
    update: '今日更新 2 话',
    desc: '穿越成亡国医女的她，用一手医术和过人胆识，在暴君身边步步为营，从人人可欺的阶下囚，一步步改写命运的走向。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20confident%20young%20woman%20in%20traditional%20hanbok%20robes%20holding%20a%20medical%20kit%2C%20standing%20before%20a%20dark%20palace%20throne%20room%2C%20vibrant%20coral%20and%20amber%20warm%20lighting%2C%20anime%20style%2C%20clean%20bold%20linework%2C%20dramatic%20composition%2C%20high%20detail%20digital%20painting&width=480&height=640&seq=cover-w1&orientation=portrait',
    hot: true,
    color: '#ff5f2e',
  },
  {
    id: 'w2',
    title: '契约恋爱进行时',
    korean: '계약 연애 중',
    genre: '都市 · 甜宠',
    tags: ['职场', '先婚后爱', '治愈'],
    status: '连载中',
    rating: '9.4',
    chapters: '全 96 话',
    update: '今日更新 1 话',
    desc: '为应付家族催婚，冷静理性的CFO与元气满满的插画师签下恋爱契约，假戏真做间，两个世界开始慢慢交叠。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20manhwa%20cover%20of%20a%20charming%20couple%20sharing%20an%20umbrella%20under%20city%20neon%20lights%2C%20warm%20peach%20and%20amber%20palette%2C%20cute%20anime%20illustration%2C%20soft%20glow%2C%20romantic%20atmosphere%2C%20clean%20lineart%2C%20detailed%20digital%20art&width=480&height=640&seq=cover-w2&orientation=portrait',
    hot: true,
    color: '#f2c94c',
  },
  {
    id: 'w3',
    title: '魔王回归第一天',
    korean: '마왕 귀환',
    genre: '奇幻 · 冒险',
    tags: ['异世界', '热血', '战斗'],
    status: '连载中',
    rating: '9.7',
    chapters: '全 210 话',
    update: '今日更新 3 话',
    desc: '陨落百年的魔王意外重生在废弃封印中，为夺回失落的领地，他带着仅存的小队，踏上重新改写世界格局的征途。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20a%20powerful%20dark%20demon%20lord%20with%20glowing%20amber%20eyes%2C%20flowing%20black%20robe%20and%20magic%20flames%2C%20epic%20battle%20background%2C%20warm%20coral%20and%20orange%20lighting%2C%20anime%20style%2C%20bold%20linework%2C%20dramatic%20high%20detail%20digital%20painting&width=480&height=640&seq=cover-w3&orientation=portrait',
    hot: true,
    color: '#7bab97',
  },
  {
    id: 'w4',
    title: '她穿进狗血文里当配角',
    korean: '악역의 여주',
    genre: '穿书 · 沙雕',
    tags: ['轻松', '反套路', '搞笑'],
    status: '已完结',
    rating: '9.3',
    chapters: '全 145 话',
    update: '已完结',
    desc: '穿进狗血小说当恶毒女配的她，决定摆烂到底，却没想到所有角色都开始按她的剧本暴走，剧情彻底失控。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%20of%20a%20playful%20anime%20girl%20winking%20with%20dramatic%20manga%20speed%20lines%20and%20star%20bursts%2C%20vibrant%20warm%20yellow%20and%20coral%20background%2C%20fun%20energetic%20cartoon%20style%2C%20thick%20outlines%2C%20high%20energy%20digital%20illustration&width=480&height=640&seq=cover-w4&orientation=portrait',
    color: '#ff9a73',
  },
  {
    id: 'w5',
    title: '深夜食堂的执事',
    korean: '심야 식당 집사',
    genre: '治愈 · 美食',
    tags: ['日常', '温情', '美食'],
    status: '连载中',
    rating: '9.2',
    chapters: '全 88 话',
    update: '今日更新 1 话',
    desc: '只接待特殊客人的深夜食堂里，神秘的执事用一道料理，换一个不为人知的故事，抚慰每一颗疲惫的心。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%20of%20a%20mysterious%20butler%20in%20a%20cozy%20warm%20night%20restaurant%2C%20steaming%20food%20and%20warm%20lamp%20glow%2C%20coral%20and%20amber%20tones%2C%20gentle%20anime%20illustration%2C%20soft%20atmosphere%2C%20clean%20linework%2C%20detailed%20digital%20art&width=480&height=640&seq=cover-w5&orientation=portrait',
    color: '#f5d66b',
  },
  {
    id: 'w6',
    title: '机械心脏与少女',
    korean: '기계 심장',
    genre: '科幻 · 恋爱',
    tags: ['机甲', '虐恋', '末世'],
    status: '连载中',
    rating: '9.5',
    chapters: '全 132 话',
    update: '今日更新 2 话',
    desc: '末日废土上，为保护唯一的少女，冰冷的战争机械装上了会跳动的"心"，一段跨越人类与机械界限的爱恋就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%20of%20a%20girl%20hugging%20a%20giant%20mecha%20warrior%20in%20a%20post-apocalyptic%20wasteland%20at%20sunset%2C%20warm%20orange%20and%20teal%20lighting%2C%20emotional%20anime%20illustration%2C%20cinematic%20composition%2C%20high%20detail%20digital%20painting&width=480&height=640&seq=cover-w6&orientation=portrait',
    hot: true,
    color: '#7bab97',
  },
  {
    id: 'w7',
    title: '重生之商界女总裁',
    korean: '환생 사장님',
    genre: '重生 · 商战',
    tags: ['爽文', '复仇', '职场'],
    status: '连载中',
    rating: '9.4',
    chapters: '全 178 话',
    update: '今日更新 2 话',
    desc: '惨遭背叛后重生回十年前的她，带着前世记忆重整旗鼓，在风云变幻的商界里步步为营，让所有背叛者付出代价。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20business%20manhwa%20cover%20of%20a%20confident%20powerful%20businesswoman%20in%20a%20sharp%20suit%20against%20a%20city%20skyline%2C%20warm%20coral%20and%20amber%20backlight%2C%20strong%20bold%20anime%20illustration%2C%20dynamic%20angle%2C%20high%20detail%20digital%20painting&width=480&height=640&seq=cover-w7&orientation=portrait',
    color: '#ff7a4d',
  },
  {
    id: 'w8',
    title: '关于我被学弟捡到这件事',
    korean: '후배에게 줍다',
    genre: '校园 · 青春',
    tags: ['甜恋', '校园', '纯爱'],
    status: '已完结',
    rating: '9.1',
    chapters: '全 76 话',
    update: '已完结',
    desc: '落榜失意的学姐在雨夜被温柔学弟"捡"回家，平淡日常里悄然发芽的心动，写满了青春最干净的模样。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%20of%20a%20gentle%20boy%20handing%20an%20umbrella%20to%20a%20shy%20senior%20girl%20on%20a%20rainy%20campus%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20anime%20illustration%2C%20sweet%20atmosphere%2C%20clean%20lineart%2C%20detailed%20digital%20art&width=480&height=640&seq=cover-w8&orientation=portrait',
    color: '#f8e28f',
  },
  {
    id: 'w9',
    title: '死对头今天也在撩我',
    korean: '악연',
    genre: '都市 · 欢喜冤家',
    tags: ['宿敌', '搞笑', '甜宠'],
    status: '连载中',
    rating: '9.3',
    chapters: '全 112 话',
    update: '今日更新 1 话',
    desc: '从小到大的死对头，如今却开始处处"撩"她。嘴上互怼到天荒地老，心里却早已兵荒马乱，一场胜负难分的攻心战。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20enemies-to-lovers%20manhwa%20cover%20of%20two%20competitive%20young%20people%20glaring%20with%20playful%20sparks%20between%20them%2C%20vibrant%20warm%20orange%20and%20yellow%20background%2C%20fun%20anime%20illustration%2C%20comic%20style%20speed%20lines%2C%20high%20energy%2C%20detailed%20digital%20art&width=480&height=640&seq=cover-w9&orientation=portrait',
    color: '#ff9a73',
  },
  {
    id: 'w10',
    title: '我靠捡漏爆红了',
    korean: '로또 급의 행운',
    genre: '爽文 · 娱乐',
    tags: ['逆袭', '轻喜剧', '娱乐圈'],
    status: '连载中',
    rating: '9.2',
    chapters: '全 104 话',
    update: '今日更新 1 话',
    desc: '平平无奇的她因一场意外"捡漏"走红网络，从十八线小透明一路逆袭，把一手烂牌打成王炸的人生。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20a%20cheerful%20girl%20in%20stage%20spotlight%20holding%20a%20lucky%20golden%20card%2C%20sparkles%20and%20confetti%2C%20warm%20coral%20and%20amber%20palette%2C%20energetic%20anime%20illustration%2C%20bold%20linework%2C%20high%20detail%20digital%20art&width=480&height=640&seq=cover-w10&orientation=portrait',
    color: '#f2c94c',
  },
];

export const workTags = [
  '宫廷逆袭', '都市甜宠', '奇幻冒险', '穿书沙雕', '治愈美食',
  '科幻虐恋', '重生爽文', '校园纯爱', '欢喜冤家', '娱乐圈',
];

export const genreList = [
  { name: '言情恋爱', count: 368, icon: 'ri-heart-3-fill' },
  { name: '奇幻玄幻', count: 421, icon: 'ri-sparkling-2-fill' },
  { name: '热血战斗', count: 296, icon: 'ri-flashlight-fill' },
  { name: '都市职场', count: 254, icon: 'ri-briefcase-4-fill' },
  { name: '校园青春', count: 312, icon: 'ri-graduation-cap-fill' },
  { name: '悬疑惊悚', count: 187, icon: 'ri-eye-off-fill' },
];